module.exports = __webpack_public_path__ + "static/media/bullseye.0c9f2843.gif";